import React, { useEffect, useRef, useState } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import s from './ThemesShowcase.css';

/*
 * Ролик на главной: девять встроенных тем расширения сменяют друг друга.
 * Исходник — tools/home-animation (Remotion), файлы — public/img/home.
 *
 * Сервер рисует только постер. Видео выбирается уже в браузере, по ширине
 * экрана: на телефоне — вертикальная версия 3:4 с крупными подписями. Так
 * качается один ролик, а не оба. При «уменьшить движение» остаётся постер.
 */
const MOBILE = '(max-width: 640px)';
const BASE = '/img/home/themes-';

const THEMES =
	'Minimal, Workday, Study, Countdown, Balance, Morning briefing, Markets, Speed dial and Cozy evening';

export default function ThemesShowcase() {
	useStyles(s);
	const video = useRef(null);
	const [variant, setVariant] = useState(null);

	useEffect(() => {
		if (
			typeof window === 'undefined' ||
			!window.matchMedia ||
			window.matchMedia('(prefers-reduced-motion: reduce)').matches
		) {
			return undefined;
		}

		const query = window.matchMedia(MOBILE);
		const pick = () => setVariant(query.matches ? 'mobile' : 'desktop');
		pick();

		// Повернули телефон или сузили окно — ролик меняется вместе с раскладкой
		if (query.addEventListener) {
			query.addEventListener('change', pick);
			return () => query.removeEventListener('change', pick);
		}

		query.addListener(pick);
		return () => query.removeListener(pick);
	}, []);

	useEffect(() => {
		if (video.current) {
			// muted в JSX React 16 не всегда ставит атрибут — без него браузер не даст автозапуск
			video.current.muted = true;
			const playing = video.current.play();
			if (playing && playing.catch) {
				playing.catch(() => {});
			}
		}
	}, [variant]);

	return (
		<figure className={s.root}>
			<picture className={s.poster}>
				<source media={MOBILE} srcSet={`${BASE}mobile-poster.webp`} />
				<img
					src={`${BASE}desktop-poster.webp`}
					alt={`New Tab Studio switching between its nine built-in themes: ${THEMES}`}
					width={1280}
					height={720}
				/>
			</picture>

			{variant && (
				<video
					key={variant}
					ref={video}
					className={s.video}
					autoPlay
					muted
					loop
					playsInline
					preload="auto"
					poster={`${BASE}${variant}-poster.webp`}
					aria-hidden="true"
				>
					<source src={`${BASE}${variant}.webm`} type="video/webm" />
					<source src={`${BASE}${variant}.mp4`} type="video/mp4" />
				</video>
			)}
		</figure>
	);
}
